module.exports = __webpack_public_path__ + "img/logoS.5e2faf49.png";